import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { alertsSection } from "Pages/ReportsAlerts/Alerts/@signals"
import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"


export default function CreateAlertsButton() {

	const { onGenerateAlert } = useAlertsTableData()

	return <ButtonLoadingSeeker
		startIcon={<IconSeeker icon="cowbell-circle-plus" />}
		sx={{ m: 1, mr: 0 }}
		tooltip={`New condition`}
		onClick={() => alertsDrawerData.value = onGenerateAlert({ type: alertsSection.value })}
	>
		New condition
	</ButtonLoadingSeeker>
}